/**
 * Model labs whose display names start with D-L, in catalog order.
 *
 * Generated by `pnpm logos:sync`; see `../model-labs.ts`.
 */
export const LABS_D_L = [
    {
        id: 'dalle',
        name: 'DALL\u00b7E',
        light: 'dalle/dalle-light.svg',
        dark: 'dalle/dalle-dark.svg',
    },
    { id: 'dbrx', name: 'DBRX', light: 'dbrx/dbrx-light.svg', dark: 'dbrx/dbrx-dark.svg' },
    {
        id: 'deepcogito',
        name: 'Deep Cogito',
        light: 'deepcogito/deepcogito-light.svg',
        dark: 'deepcogito/deepcogito-dark.svg',
    },
    {
        id: 'deepai',
        name: 'DeepAI',
        light: 'deepai/deepai-light.svg',
        dark: 'deepai/deepai-dark.svg',
    },
    {
        id: 'deepinfra',
        name: 'DeepInfra',
        light: 'deepinfra/deepinfra-light.svg',
        dark: 'deepinfra/deepinfra-dark.svg',
    },
    { id: 'deepl', name: 'DeepL', light: 'deepl/deepl-light.svg', dark: 'deepl/deepl-dark.svg' },
    {
        id: 'deepseek',
        name: 'DeepSeek',
        light: 'deepseek/deepseek-light.svg',
        dark: 'deepseek/deepseek-dark.svg',
    },
    { id: 'devin', name: 'Devin', light: 'devin/devin-light.svg', dark: 'devin/devin-dark.svg' },
    { id: 'dify', name: 'Dify', light: 'dify/dify-light.svg', dark: 'dify/dify-dark.svg' },
    { id: 'doc2x', name: 'Doc2X', light: 'doc2x/doc2x-light.svg', dark: 'doc2x/doc2x-dark.svg' },
    {
        id: 'docsearch',
        name: 'DocSearch',
        light: 'docsearch/docsearch-light.svg',
        dark: 'docsearch/docsearch-dark.svg',
    },
    {
        id: 'dolphin',
        name: 'Dolphin',
        light: 'dolphin/dolphin-light.svg',
        dark: 'dolphin/dolphin-dark.svg',
    },
    {
        id: 'doubao',
        name: 'Doubao',
        light: 'doubao/doubao-light.svg',
        dark: 'doubao/doubao-dark.svg',
    },
    {
        id: 'dreammachine',
        name: 'Dream Machine',
        light: 'dreammachine/dreammachine-light.svg',
        dark: 'dreammachine/dreammachine-dark.svg',
    },
    {
        id: 'elevenlabs',
        name: 'ElevenLabs',
        light: 'elevenlabs/elevenlabs-light.svg',
        dark: 'elevenlabs/elevenlabs-dark.svg',
    },
    {
        id: 'elevenx',
        name: 'ElevenX',
        light: 'elevenx/elevenx-light.svg',
        dark: 'elevenx/elevenx-dark.svg',
    },
    {
        id: 'essentialai',
        name: 'Essential AI',
        light: 'essentialai/essentialai-light.svg',
        dark: 'essentialai/essentialai-dark.svg',
    },
    { id: 'exa', name: 'Exa', light: 'exa/exa-light.svg', dark: 'exa/exa-dark.svg' },
    { id: 'fal', name: 'Fal', light: 'fal/fal-light.svg', dark: 'fal/fal-dark.svg' },
    {
        id: 'fastgpt',
        name: 'FastGPT',
        light: 'fastgpt/fastgpt-light.svg',
        dark: 'fastgpt/fastgpt-dark.svg',
    },
    {
        id: 'featherless',
        name: 'Featherless',
        light: 'featherless/featherless-light.svg',
        dark: 'featherless/featherless-dark.svg',
    },
    { id: 'figma', name: 'Figma', light: 'figma/figma-light.svg', dark: 'figma/figma-dark.svg' },
    {
        id: 'firecrawl',
        name: 'Firecrawl',
        light: 'firecrawl/firecrawl-light.svg',
        dark: 'firecrawl/firecrawl-dark.svg',
    },
    {
        id: 'fireworks',
        name: 'Fireworks AI',
        light: 'fireworks/fireworks-light.svg',
        dark: 'fireworks/fireworks-dark.svg',
    },
    {
        id: 'fishaudio',
        name: 'Fish Audio',
        light: 'fishaudio/fishaudio-light.svg',
        dark: 'fishaudio/fishaudio-dark.svg',
    },
    { id: 'flora', name: 'Flora', light: 'flora/flora-light.svg', dark: 'flora/flora-dark.svg' },
    {
        id: 'flowith',
        name: 'Flowith',
        light: 'flowith/flowith-light.svg',
        dark: 'flowith/flowith-dark.svg',
    },
    { id: 'flux', name: 'FLUX', light: 'flux/flux-light.svg', dark: 'flux/flux-dark.svg' },
    {
        id: 'friendli',
        name: 'Friendli',
        light: 'friendli/friendli-light.svg',
        dark: 'friendli/friendli-dark.svg',
    },
    {
        id: 'gemini',
        name: 'Gemini',
        light: 'gemini/gemini-light.svg',
        dark: 'gemini/gemini-dark.svg',
    },
    {
        id: 'geminicli',
        name: 'Gemini CLI',
        light: 'geminicli/geminicli-light.svg',
        dark: 'geminicli/geminicli-dark.svg',
    },
    { id: 'gemma', name: 'Gemma', light: 'gemma/gemma-light.svg', dark: 'gemma/gemma-dark.svg' },
    {
        id: 'giteeai',
        name: 'Giteeai',
        light: 'giteeai/giteeai-light.svg',
        dark: 'giteeai/giteeai-dark.svg',
    },
    {
        id: 'github',
        name: 'GitHub',
        light: 'github/github-light.svg',
        dark: 'github/github-dark.svg',
    },
    {
        id: 'githubcopilot',
        name: 'GitHub Copilot',
        light: 'githubcopilot/githubcopilot-light.svg',
        dark: 'githubcopilot/githubcopilot-dark.svg',
    },
    { id: 'glama', name: 'Glama', light: 'glama/glama-light.svg', dark: 'glama/glama-dark.svg' },
    { id: 'glif', name: 'Glif', light: 'glif/glif-light.svg', dark: 'glif/glif-dark.svg' },
    { id: 'glmv', name: 'GLM-V', light: 'glmv/glmv-light.svg', dark: 'glmv/glmv-dark.svg' },
    {
        id: 'google',
        name: 'Google',
        light: 'google/google-light.svg',
        dark: 'google/google-dark.svg',
    },
    {
        id: 'googlecloud',
        name: 'Google Cloud',
        light: 'googlecloud/googlecloud-light.svg',
        dark: 'googlecloud/googlecloud-dark.svg',
    },
    {
        id: 'colab',
        name: 'Google Colab',
        light: 'colab/colab-light.svg',
        dark: 'colab/colab-dark.svg',
    },
    {
        id: 'deepmind',
        name: 'Google DeepMind',
        light: 'deepmind/deepmind-light.svg',
        dark: 'deepmind/deepmind-dark.svg',
    },
    { id: 'goose', name: 'Goose', light: 'goose/goose-light.svg', dark: 'goose/goose-dark.svg' },
    {
        id: 'gradio',
        name: 'Gradio',
        light: 'gradio/gradio-light.svg',
        dark: 'gradio/gradio-dark.svg',
    },
    {
        id: 'greptile',
        name: 'Greptile',
        light: 'greptile/greptile-light.svg',
        dark: 'greptile/greptile-dark.svg',
    },
    { id: 'grok', name: 'Grok', light: 'grok/grok-light.svg', dark: 'grok/grok-dark.svg' },
    { id: 'groq', name: 'Groq', light: 'groq/groq-light.svg', dark: 'groq/groq-dark.svg' },
    {
        id: 'hailuo',
        name: 'Hailuo',
        light: 'hailuo/hailuo-light.svg',
        dark: 'hailuo/hailuo-dark.svg',
    },
    {
        id: 'haiper',
        name: 'Haiper',
        light: 'haiper/haiper-light.svg',
        dark: 'haiper/haiper-dark.svg',
    },
    {
        id: 'happyhorse',
        name: 'Happy Horse',
        light: 'happyhorse/happyhorse-light.svg',
        dark: 'happyhorse/happyhorse-dark.svg',
    },
    { id: 'hedra', name: 'Hedra', light: 'hedra/hedra-light.svg', dark: 'hedra/hedra-dark.svg' },
    {
        id: 'hermesagent',
        name: 'Hermes',
        light: 'hermesagent/hermesagent-light.svg',
        dark: 'hermesagent/hermesagent-dark.svg',
    },
    {
        id: 'higress',
        name: 'Higress',
        light: 'higress/higress-light.svg',
        dark: 'higress/higress-dark.svg',
    },
    {
        id: 'huawei',
        name: 'Huawei',
        light: 'huawei/huawei-light.svg',
        dark: 'huawei/huawei-dark.svg',
    },
    {
        id: 'huaweicloud',
        name: 'Huawei Cloud',
        light: 'huaweicloud/huaweicloud-light.svg',
        dark: 'huaweicloud/huaweicloud-dark.svg',
    },
    {
        id: 'huggingface',
        name: 'Hugging Face',
        light: 'huggingface/huggingface-light.svg',
        dark: 'huggingface/huggingface-dark.svg',
    },
    {
        id: 'hunyuan',
        name: 'Hunyuan',
        light: 'hunyuan/hunyuan-light.svg',
        dark: 'hunyuan/hunyuan-dark.svg',
    },
    {
        id: 'hyperbolic',
        name: 'Hyperbolic',
        light: 'hyperbolic/hyperbolic-light.svg',
        dark: 'hyperbolic/hyperbolic-dark.svg',
    },
    { id: 'ibm', name: 'IBM', light: 'ibm/ibm-light.svg', dark: 'ibm/ibm-dark.svg' },
    {
        id: 'ideogram',
        name: 'Ideogram',
        light: 'ideogram/ideogram-light.svg',
        dark: 'ideogram/ideogram-dark.svg',
    },
    {
        id: 'iflytekcloud',
        name: 'iFlytek Cloud',
        light: 'iflytekcloud/iflytekcloud-light.svg',
        dark: 'iflytekcloud/iflytekcloud-dark.svg',
    },
    {
        id: 'inception',
        name: 'Inception',
        light: 'inception/inception-light.svg',
        dark: 'inception/inception-dark.svg',
    },
    {
        id: 'inference',
        name: 'Inference.net',
        light: 'inference/inference-light.svg',
        dark: 'inference/inference-dark.svg',
    },
    {
        id: 'infermatic',
        name: 'Infermatic',
        light: 'infermatic/infermatic-light.svg',
        dark: 'infermatic/infermatic-dark.svg',
    },
    {
        id: 'infinigence',
        name: 'Infinigence',
        light: 'infinigence/infinigence-light.svg',
        dark: 'infinigence/infinigence-dark.svg',
    },
    {
        id: 'inflection',
        name: 'Inflection AI',
        light: 'inflection/inflection-light.svg',
        dark: 'inflection/inflection-dark.svg',
    },
    {
        id: 'internlm',
        name: 'InternLM',
        light: 'internlm/internlm-light.svg',
        dark: 'internlm/internlm-dark.svg',
    },
    {
        id: 'jimeng',
        name: 'Jimeng',
        light: 'jimeng/jimeng-light.svg',
        dark: 'jimeng/jimeng-dark.svg',
    },
    { id: 'jina', name: 'Jina AI', light: 'jina/jina-light.svg', dark: 'jina/jina-dark.svg' },
    { id: 'junie', name: 'Junie', light: 'junie/junie-light.svg', dark: 'junie/junie-dark.svg' },
    { id: 'kagi', name: 'Kagi', light: 'kagi/kagi-light.svg', dark: 'kagi/kagi-dark.svg' },
    {
        id: 'kilocode',
        name: 'Kilo Code',
        light: 'kilocode/kilocode-light.svg',
        dark: 'kilocode/kilocode-dark.svg',
    },
    { id: 'kimi', name: 'Kimi', light: 'kimi/kimi-light.svg', dark: 'kimi/kimi-dark.svg' },
    { id: 'kiro', name: 'Kiro', light: 'kiro/kiro-light.svg', dark: 'kiro/kiro-dark.svg' },
    { id: 'kling', name: 'Kling', light: 'kling/kling-light.svg', dark: 'kling/kling-dark.svg' },
    {
        id: 'kluster',
        name: 'Kluster',
        light: 'kluster/kluster-light.svg',
        dark: 'kluster/kluster-dark.svg',
    },
    {
        id: 'kolors',
        name: 'Kolors',
        light: 'kolors/kolors-light.svg',
        dark: 'kolors/kolors-dark.svg',
    },
    { id: 'krea', name: 'Krea', light: 'krea/krea-light.svg', dark: 'krea/krea-dark.svg' },
    {
        id: 'kwaikat',
        name: 'KwaiKat',
        light: 'kwaikat/kwaikat-light.svg',
        dark: 'kwaikat/kwaikat-dark.svg',
    },
    {
        id: 'kwaipilot',
        name: 'KwaiPilot',
        light: 'kwaipilot/kwaipilot-light.svg',
        dark: 'kwaipilot/kwaipilot-dark.svg',
    },
    {
        id: 'lambda',
        name: 'Lambda',
        light: 'lambda/lambda-light.svg',
        dark: 'lambda/lambda-dark.svg',
    },
    {
        id: 'langchain',
        name: 'LangChain',
        light: 'langchain/langchain-light.svg',
        dark: 'langchain/langchain-dark.svg',
    },
    {
        id: 'langfuse',
        name: 'Langfuse',
        light: 'langfuse/langfuse-light.svg',
        dark: 'langfuse/langfuse-dark.svg',
    },
    {
        id: 'langgraph',
        name: 'LangGraph',
        light: 'langgraph/langgraph-light.svg',
        dark: 'langgraph/langgraph-dark.svg',
    },
    {
        id: 'langsmith',
        name: 'LangSmith',
        light: 'langsmith/langsmith-light.svg',
        dark: 'langsmith/langsmith-dark.svg',
    },
    {
        id: 'leptonai',
        name: 'Lepton AI',
        light: 'leptonai/leptonai-light.svg',
        dark: 'leptonai/leptonai-dark.svg',
    },
    { id: 'lg', name: 'LG AI Research', light: 'lg/lg-light.svg', dark: 'lg/lg-dark.svg' },
    {
        id: 'lightricks',
        name: 'Lightricks',
        light: 'lightricks/lightricks-light.svg',
        dark: 'lightricks/lightricks-dark.svg',
    },
    {
        id: 'liquid',
        name: 'Liquid AI',
        light: 'liquid/liquid-light.svg',
        dark: 'liquid/liquid-dark.svg',
    },
    {
        id: 'livekit',
        name: 'LiveKit',
        light: 'livekit/livekit-light.svg',
        dark: 'livekit/livekit-dark.svg',
    },
    {
        id: 'llamaindex',
        name: 'LlamaIndex',
        light: 'llamaindex/llamaindex-light.svg',
        dark: 'llamaindex/llamaindex-dark.svg',
    },
    { id: 'llava', name: 'LLaVA', light: 'llava/llava-light.svg', dark: 'llava/llava-dark.svg' },
    {
        id: 'llmapi',
        name: 'LLM API',
        light: 'llmapi/llmapi-light.svg',
        dark: 'llmapi/llmapi-dark.svg',
    },
    {
        id: 'lmstudio',
        name: 'LM Studio',
        light: 'lmstudio/lmstudio-light.svg',
        dark: 'lmstudio/lmstudio-dark.svg',
    },
    { id: 'lobehub', name: 'LobeHub', light: 'lobehub/lobehub.svg', dark: 'lobehub/lobehub.svg' },
    {
        id: 'longcat',
        name: 'LongCat',
        light: 'longcat/longcat-light.svg',
        dark: 'longcat/longcat-dark.svg',
    },
    {
        id: 'lovable',
        name: 'Lovable',
        light: 'lovable/lovable-light.svg',
        dark: 'lovable/lovable-dark.svg',
    },
    {
        id: 'lovart',
        name: 'Lovart',
        light: 'lovart/lovart-light.svg',
        dark: 'lovart/lovart-dark.svg',
    },
    { id: 'luma', name: 'Luma', light: 'luma/luma-light.svg', dark: 'luma/luma-dark.svg' },
];
//# sourceMappingURL=labs-d-l.js.map